// extracted by mini-css-extract-plugin
export default {"root":"f4Oik","text":"IOKw1","highlight":"L2eOO","closeButton":"VUeBJ"};